import { render, staticRenderFns } from "./bscClueOnlineMatrixAdd.vue?vue&type=template&id=3b132292"
import script from "./bscClueOnlineMatrixAdd.vue?vue&type=script&lang=js"
export * from "./bscClueOnlineMatrixAdd.vue?vue&type=script&lang=js"
import style0 from "./bscClueOnlineMatrixAdd.vue?vue&type=style&index=0&id=3b132292&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports